export enum TestimonialActionTypes {
    API_RESPONSE_SUCCESS = "@@testimonials/API_RESPONSE_SUCCESS",
    API_RESPONSE_ERROR = "@@testimonials/API_RESPONSE_ERROR",
  
    CREATE_TESTIMONIAL = "@@testimonials/CREATE_TESTIMONIAL",
    GET_TESTIMONIAL = "@@testimonials/GET_TESTIMONIAL",
    UPDATE_TESTIMONIAL = "@@testimonials/UPDATE_TESTIMONIAL",
    DELETE_TESTIMONIAL = "@@testimonials/DELETE_TESTIMONIAL",
  }